import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import uiReducer from "./slices/uiSlice";
import globalReducer from "./slices/globalSlice";
import permissionReducer from "./slices/permissionSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    global: globalReducer,
    permissions: permissionReducer,
  },

  devTools: process.env.NODE_ENV !== "production",
});

export default store;
